import { CheckIcon, CloseIcon, RefreshIcon } from 'Asset/icon';

const getStatusIcon = (status) => {
  switch (status) {
    case 'Diterima':
      return <CheckIcon size={'12px'} />;
    case 'Ditolak':
      return <CloseIcon size={'12px'} />;
    case 'Diproses':
      return <RefreshIcon size={'12px'} />;
    default:
      return '';
  }
};

export default getStatusIcon;
